<template>
  <div class="bottom-sheet__container">
    <VueBottomSheet
      ref="sheet"
      @opened="emitOpened"
      @closed="emitClosed"
      :blocking="false"
      teleportTo="body"
      :teleport-defer="true"
    >
      <slot name="content" />
    </VueBottomSheet>
  </div>
</template>

<script>
import VueBottomSheet from "@douxcode/vue-spring-bottom-sheet";
import "@douxcode/vue-spring-bottom-sheet/dist/style.css";

export default {
  name: "BottomSheet",
  components: { VueBottomSheet },
  props: {
    modelValue: { type: Boolean, default: false },
    maxHeight: { type: String, default: '100%' }
  },
  watch: {
    modelValue(newVal) {
      const sheet = this.$refs.sheet;
      if (!sheet) return;

      if (newVal) sheet.open();
      else sheet.close();
    }
  },
  methods: {
    emitOpened() {
      this.$emit("update:modelValue", true);
      this.$emit("opened");
    },
    emitClosed() {
      this.$emit("update:modelValue", false);
      this.$emit("closed");
    }
  }
};
</script>


<style>

</style>